module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-block', {
    staticClass: "v-cpanel-icons"
  }, [_c('f7-grid', {
    attrs: {
      "no-gutter": ""
    }
  }, [_vm._l((_vm.items), function(item) {
    return (!item.items) ? _c('f7-col', {
      key: item.name,
      attrs: {
        "width": "33",
        "tablet-width": "20"
      }
    }, [_c('a', {
      class: 'button ' + (item.color ? item.color : ' ') + (item.disable ? ' disabled' : ' '),
      attrs: {
        "href": item.link
      },
      on: {
        "click": function($event) {
          _vm.onClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.label))])])]) : _vm._l((item.items), function(subitem) {
      return _c('f7-col', {
        key: subitem.name,
        attrs: {
          "width": "33",
          "tablet-width": "20"
        }
      }, [_c('a', {
        class: 'button ' + (subitem.color ? subitem.color : ' ') + (subitem.disable ? ' disabled' : ' '),
        attrs: {
          "href": subitem.link
        },
        on: {
          "click": function($event) {
            _vm.onClick(subitem)
          }
        }
      }, [_c('span', {
        staticClass: "icon"
      }), _vm._v(" "), _c('span', {
        staticClass: "label"
      }, [_vm._v(_vm._s(subitem.label))])])])
    })
  }), _vm._v(" "), _vm._l(((_vm.Cols - (_vm.Length % _vm.Cols))), function(i) {
    return _c('f7-col', {
      key: i,
      attrs: {
        "width": "33",
        "tablet-width": "20"
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03209f89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VCpanelIcons.vue
// module id = 131
// module chunks = 1